import React from 'react'
import { makeStyles, Grid, Avatar, Button } from '@material-ui/core'
import get from 'lodash/get'
import SimpleImageInput from './SimpleImageInput'

const useStyle = makeStyles({
    avatar: props => ({
        height: props.size,
        width: props.size,
    }),
    button: {
        color: '#fff',
        marginTop:'-70px'
    },
    dropzone: {
        display: 'none'
    },
    img: {
        display: 'none'
    }
});


const AvatarInput = props => {
    const classes = useStyle(props);
    const img = React.useRef('');

    const AvatarImageField = props => {
        const {
            record,
            source,
            title
        } = props;

        const sourceValue = get(record, source);

        const titleValue = get(record, title) || title;

        return (
            <img
                title={titleValue}
                alt={titleValue}
                src={sourceValue}
                ref={img}
                className={classes.img}
            />
        );
    }

    return (
        <React.Fragment>
            <Grid container
                direction='column'
                alignItems="center"
                spacing={2}>
                <Grid item>
                    <Avatar
                        src={img.current.src}
                        title={img.current.title}
                        alt={img.current.alt}
                        className={classes.avatar} />
                </Grid>
                <Grid item>
                    <SimpleImageInput
                        id="button-file"
                        source={props.source}
                        label=' '
                        accept="image/*"

                    >
                    <AvatarImageField source='src' />
                    </SimpleImageInput>
                    <label htmlFor="button-file">
                        <Button
                            className={classes.button}
                            size="small"
                            variant="contained"
                            color="primary"
                            component='span' >
                            Add Photo
                 </Button>
                    </label>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}




export default AvatarInput;